const API_BASE = import.meta.env.VITE_API_BASE || '/api'

/* =========================================================================
   apiAsset — turn a stored file path into a URL that works wherever the
   site is served from.

   Avatars and uploads were being built as `http://localhost/spectranox/<path>`,
   which is three separate faults in one string: it points at the visitor's own
   machine, it names a folder this project does not use, and it is plain http
   on a page served over https, so a browser blocks it as mixed content before
   it can even fail to load.

   The database stores two shapes, and both have to keep working:

     'api/usersdp/dp_6.png'   written by update_profile.php — already names
                              the api folder, so it is relative to the site root
     'uploads/1788245708.png' written by the project uploader — relative to
                              the api folder

   Everything is returned root-relative, so it resolves identically from
   /portfolio/3 and from the homepage, and it inherits the page's own scheme
   and host rather than hardcoding either.
   ========================================================================= */
export function apiAsset(value) {
  const v = String(value || '').trim()
  if (!v) return ''
  // absolute URLs and blob: previews are already final
  if (/^(https?:)?\/\//i.test(v) || v.startsWith('blob:') || v.startsWith('data:')) return v
  if (v.startsWith('/')) return v
  const clean = v.replace(/^\.\//, '')
  return clean.startsWith('api/') ? `/${clean}` : `${API_BASE}/${clean}`
}

export default apiAsset
